const topics = [
  { tag: '明星塌房', icon: 'ri-alert-line', heat: '9.8万', hot: true },
  { tag: '综艺翻车', icon: 'ri-emotion-sad-line', heat: '7.2万', hot: true },
  { tag: '恋情曝光', icon: 'ri-heart-line', heat: '6.5万', hot: true },
  { tag: '网红争议', icon: 'ri-user-voice-line', heat: '5.3万', hot: false },
  { tag: '影视爆料', icon: 'ri-film-line', heat: '4.8万', hot: false },
  { tag: '私生活揭秘', icon: 'ri-key-2-line', heat: '4.1万', hot: true },
  { tag: '合同纠纷', icon: 'ri-file-text-line', heat: '3.6万', hot: false },
  { tag: '代言翻车', icon: 'ri-shopping-bag-line', heat: '3.1万', hot: false },
  { tag: '综艺剪辑', icon: 'ri-scissors-line', heat: '2.8万', hot: false },
  { tag: '片场花絮', icon: 'ri-camera-line', heat: '2.2万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">热门话题</h2>
              <p className="text-sm text-foreground-600 mt-1">大家都在吃这些瓜</p>
            </div>
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium whitespace-nowrap">
              <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
              实时热度
            </span>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#carousel"
                className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  topic.hot ? 'bg-primary-100' : 'bg-secondary-100'
                }`}>
                  <i className={`${topic.icon} text-lg ${
                    topic.hot ? 'text-primary-600' : 'text-secondary-600'
                  } w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <span className="text-sm font-bold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {topic.tag}
                </span>
                <span className="text-xs text-foreground-500">{topic.heat}热度</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}